import React from "react";

import { AboutMe } from "models";

import { IAccessibilityContent } from "pages/MainPage/MainPage";

import { EmptyData } from "components/common/EmptyData";

import { EditPanel } from "../EditPanel";
import { FurtherInformation } from "../FurtherInformation";
import { useTranslation } from "i18n";

export interface IAboutMeSectionContent
  extends IAccessibilityContent,
    IAccessibilityContent {
  aboutMeHeader: string;
  noAboutMePlaceholder: string;
}

export interface IAboutMeSectionProps {
  editAboutMe: () => void;
  isReadonly: boolean;
  content: IAboutMeSectionContent;
  aboutMe?: AboutMe;
}

export const AboutMeSection: React.FC<
  React.PropsWithChildren<IAboutMeSectionProps>
> = (props) => {
  const { t } = useTranslation();

  const {
    editAboutMe,
    content,
    isReadonly,
    aboutMe: { currentAppearance = "" } = {},
  } = props;

  let aboutMeContent: React.ReactNode = null;

  if (currentAppearance === "") {
    aboutMeContent = (
      <EmptyData
        theme="light"
        text={t("performer:profile.aboutMe.placeholder")}
      />
    );
  } else {
    aboutMeContent = <FurtherInformation text={currentAppearance} />;
  }

  return (
    <React.Fragment>
      <EditPanel
        header={content.aboutMeHeader}
        editFn={editAboutMe}
        hideEdit={isReadonly}
        editLinkAltText={content.editLinkAltText}
      />
      {aboutMeContent}
    </React.Fragment>
  );
};
